// extracted by mini-css-extract-plugin
export default {"imageContainer":"Z0-z","summaryPar":"_0-z","ratingCategories":"a1-z","reviewerInfo":"b1-z","reviewTypes":"c1-z","expanded":"d1-z"};